import React from "react";

// Two-column definition list used on the Association screen.
// Values render in dark grey (`text-grey` = #595959) — Dave 2026-02-17 —
// to soften the near-black `text-ink` and give the panels a calmer read.
//
// 2026-08-04 (Dave) — uniform row rhythm across all three Association
// panels: every row locks to 48px (was 32px; +50% Dave 2026-10-09) and grows a thin gray
// hairline between rows (skipped on the last row so the panel bottom
// edge stays clean).
//
// 2026-02-09 (Dave · Slice E5k) — `parenReserve` mode: when enabled, each
// positive value cell reserves 1 character-width of right-padding so that
// negative values wrapped in parens — e.g. "($27,700)" — can let their
// closing ")" overhang into that reserved space. The rightmost DIGIT of
// every value therefore stays vertically aligned; the ")" ornament lives
// outside the digit column. Used exclusively by the Contribution Summary
// panel where negatives (`Year 1 Adjustment`, `Special Assessments`) mix
// with positives in the same column.
//
// 2026-02-27 (evening · Dave) — separator lines are now drawn on the row
// container itself (a single flex `<div>` per row) rather than on the
// individual `<dt>` / `<dd>` cells. Previously each row rendered as two
// grid cells with their own bottom borders, so the CSS column-gap
// between them punched a visible 16 px gap through every hairline and
// the heavy navy rule under `Target Funding Level`. A single row-level
// border draws each rule as one continuous line across the full panel
// width.
//
// A new `separator: "hairline"` opts value forces the hairline on even
// when the row is the last row — used on Middle panel's `Study Horizon`
// so its bottom rule visually aligns with the Details panel bottom.
export default function DL({ rows, parenReserve = false }) {
  const rowH = 48;
  const rule = "1px solid #E2E8F0";
  const strongRule = "2px solid #1C4E80";
  return (
    <dl className="text-[12px] mt-2" data-testid="dl-list">
      {rows.map((row, i) => {
        const [k, v, opts] = row;
        const isLast = i === rows.length - 1;
        const bottom =
          opts?.separator === "hairline"
            ? rule
            : opts?.separator === "strong"
              ? strongRule
              : isLast
                ? "none"
                : rule;
        const isParen = parenReserve && typeof v === "string" && v.endsWith(")");
        const ddStyle = parenReserve
          ? { paddingRight: isParen ? 0 : "1ch", color: opts?.color }
          : opts?.color ? { color: opts.color } : undefined;
        return (
          <div
            key={i}
            className="flex items-center justify-between gap-4 px-2"
            style={{ height: rowH, borderBottom: bottom, background: i % 2 ? "var(--u-navy-wash)" : "#fff" }}
          >
            <dt className="text-slate m-0" style={opts?.labelColor ? { color: opts.labelColor } : undefined}>{k}</dt>
            <dd
              className="font-mono tabular-nums text-grey font-semibold m-0"
              style={ddStyle}
            >
              {v}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
